import { SidepanelContentComponent } from './sidepanel-content.component';
import { SidepanelDescriptionComponent } from './sidepanel-description.component';
import { SidepanelFooterComponent } from './sidepanel-footer.component';
import { SidepanelHeaderComponent } from './sidepanel-header.component';
import { SidepanelComponent } from './sidepanel.component';

export const SidePanelImports = [
  SidepanelComponent,
  SidepanelHeaderComponent,
  SidepanelContentComponent,
  SidepanelDescriptionComponent,
  SidepanelFooterComponent,
] as const;
